import { useState, useEffect } from 'react';
import './login.css';

function LoginPage() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const role = sessionStorage.getItem('role');
    if (token) {
      window.location.href = role === "asistan" ? "/admin/support" : "/admin";
    }
  }, []);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${apiUrl}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('role', data.role); // Rolü kaydet

        // Kullanıcı rolüne göre yönlendirme yap
        window.location.href = data.role === "asistan" ? "/admin/support" : "/admin";
      } else {
        setError(data.error || 'Geçersiz kullanıcı adı veya şifre!');
      }
    } catch (err) {
      console.error(err);
      setError('Sunucu hatası! Lütfen daha sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-container">
        <h2 className="login-title">Giriş Yap</h2>
        <form className="login-form" onSubmit={handleLogin}>
          <div className="login-input-group">
            <label className="login-label">Kullanıcı Adı</label>
            <input
              type="text"
              name="username"
              className="login-input"
              value={credentials.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="login-input-group">
            <label className="login-label">Şifre</label>
            <input
              type="password"
              name="password"
              className="login-input"
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
          </button>
          {error && <p className="login-error">{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
